import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

export default class TravelAreaTeaserTile extends Component {

	static propTypes = {
		id: PropTypes.number,
		teaser: PropTypes.shape({
			contentType: PropTypes.string,
			layout: PropTypes.number,
			publicImagePath: PropTypes.string,
			publicRetinaImagePath: PropTypes.string,
			publicLink: PropTypes.string,
			title: PropTypes.string,
			teaser: PropTypes.string,
			stringDateTime: PropTypes.string,
			additionalData: PropTypes.shape({
                inRiverImage: PropTypes.string,
			})
		})
	};

	getTeaserImageContainer() {
		return (
			<div className="teaserImageContainer">
				<div className="teaserImageWrapper">
					<picture>
						<source srcSet={this.props.teaser.additionalData.inRiverImage}/>
						<img className="teaserImage" src={this.props.teaser.additionalData.inRiverImage} alt=""/>
					</picture>
				</div>
			</div>
		);
	}

	getTeaserTextContainer() {
		return (
			<div className="teaserTextContainer">
				<div className="teaserTitle">{this.props.teaser.title}</div>
				<div className="teaserTeaser">{_.truncate(this.props.teaser.teaser, {length: 200})}</div>
			</div>
		);
	}

	getClasses() {
		let classes = [
			'teaserTile',
			this.props.teaser.contentType + 'TeaserTile'
		];

		if(this.props.teaser.layout){
			classes.push('layoutBig')
		} else {
            classes.push('layoutTeaserDefault')
		}

		return classes.join(' ');
	}

	getLink() {
		return this.props.teaser.publicLink;
	}


	render() {


		return (
			<div className={this.getClasses()}>
				<a href={this.getLink()} className="teaserLink">
					{this.getTeaserImageContainer()}
					{this.getTeaserTextContainer()}
				</a>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TeaserTile/TravelAreaTeaserTile.js